import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const footerLinks = [
    { label: "Contact", path: "/contact" },
    { label: "About Us", path: "/about" },
    { label: "FAQ", path: "/faq" },
  ];

  return (
    <footer className="bg-[#6b8e23] text-[#f4f1ed] font-[Montserrat] py-6 text-center">
      {/* Footer Navigation Links */}
      <div className="flex justify-center gap-6 mb-4">
        {footerLinks.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className="hover:underline hover:text-[#ff8c42] transition-colors duration-300"
          >
            {item.label}
          </NavLink>
        ))}
      </div>

      {/* Copyright */}
      <p className="text-sm">
        &copy; {new Date().getFullYear()}. S &amp; J. All Rights Reserved 🌱 Developed by{" "}Rowslim Technologies
      </p>
    </footer>
  );
};

export default Footer;
